import { Button } from '@vkontakte/vkui';

import { useWidget } from '../../context/WidgetContext';
import { storageManager, tokenManager } from '../../utils';

import { HAS_WIDGET_HISTORY } from '../../constants/localStorage';

import styles from './styles.module.css';

interface Props {
  onClick?: () => void;
}

export const LoadHistoryButton = ({ onClick }: Props) => {
  const { localeMessages } = useWidget();
  const hasHistory = storageManager.getItem(HAS_WIDGET_HISTORY) && storageManager.getItem(HAS_WIDGET_HISTORY) === '1';
  const isButtonShown = hasHistory && tokenManager.getIsTokenExpired();

  // Показать кнопку с подгрузкой истории (и запросом капчи), когда знаем, что была история, но токен стух
  if (!isButtonShown) {
    return null;
  }

  return (
    <div className={styles.buttonWrapper}>
      <Button className={styles.button} mode="primary" rounded onClick={onClick}>
        {localeMessages.chat.loadHistory}
      </Button>
    </div>
  );
};
